import React from "react";
import { modalOverrides, sponsorModal, textModal } from "./common";
export default [
    {
        width: "6.2%",
        height: "13.1%",
        left: "66.5%",
        top: "66.3%",
        label: "BlueVoyant - Contact us",
        isExternal: true,
        onClick: function () {
            document.getElementById("BlueVoyant").click();
        }
    },
    {
        width: "5.4%",
        height: "15.1%",
        left: "81%",
        top: "64.3%",
        label: "BlueVoyant - Corporate Solutions",
        isExternal: true,
        href: "https://assets.swoogo.com/uploads/2162478-635c2b45f282b.pdf",
        target: "_blank"
    },
    {
        width: "5.4%",
        height: "15.1%",
        left: "86.6%",
        top: "64.3%",
        label: "BlueVoyant - Terrain Supply Chain Deffence",
        isExternal: true,
        href: "https://assets.swoogo.com/uploads/2162482-635c2b925a164.pdf",
        target: "_blank"
    },
    {
        width: "6.4%",
        height: "7.1%",
        left: "75.1%",
        top: "53.2%",
        label: "BlueVoyant - Play Content",
        isExternal: true,
        modalOverrides: modalOverrides,
        modal: React.createElement("div", { style: { height: "100%", width: "100%" } },
            React.createElement("iframe", { width: "100%", height: "100%", frameBorder: "0", src: "https://player.vimeo.com/video/764605558?h=77de683ee5&autoplay=1", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true }))
    },
    {
        width: "4%",
        height: "8.6%",
        left: "69.3%",
        top: "38.3%",
        label: "BlueVoyant - Request a Demo",
        isExternal: true,
        href: "https://www.bluevoyant.com/request-a-demo",
        target: "_blank"
    },
    {
        width: "10%",
        height: "5.6%",
        left: "78.3%",
        top: "44.6%",
        label: "BlueVoyant - Social Media",
        isExternal: true,
        modalOverrides: textModal(),
        modal: sponsorModal("Booth 3", "BlueVoyant", React.createElement(React.Fragment, null, "BlueVoyant is the industry\u2019s leading integrated, end-to-end internal and external cyber defence platform that provides comprehensive defence within your organisation and across your third-party suppliers, vendors, and partners. Our proprietary data, analytics, and technology works as a force multiplier to secure your full ecosystem."), {
            twitter: "https://twitter.com/BlueVoyant",
            linkedin: "https://www.linkedin.com/company/bluevoyant/",
            company: "http://www.BlueVoyant.com"
        })
    }
];
